import type { RepositoryFile } from '@trove/core';
import { repositoryContentBlob } from './fileKinds';

const jpegCache = new Map<string, Promise<Blob>>();

/** Decode HEIC/HEIF to a JPEG blob for `<img>` / thumb previews. Cached by content. */
export function heicPreviewJpeg(file: Pick<RepositoryFile, 'content' | 'mimeType'>): Promise<Blob> {
  if (file.content === undefined) return Promise.reject(new Error('File content is not loaded'));
  const cached = jpegCache.get(file.content);
  if (cached) return cached;

  const content = file.content;
  const pending = (async () => {
    const { heicTo } = await import('heic-to');
    return heicTo({
      blob: repositoryContentBlob(file),
      type: 'image/jpeg',
      quality: 0.85,
    });
  })().catch((error) => {
    jpegCache.delete(content);
    throw error;
  });

  jpegCache.set(content, pending);
  return pending;
}
